import { render, staticRenderFns } from "./HRUserProfileModal.vue?vue&type=template&id=30f2de24&scoped=true&"
import script from "./HRUserProfileModal.vue?vue&type=script&lang=js&"
export * from "./HRUserProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2de24",
  null
  
)

export default component.exports